import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function AboutSection() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={ref} className={`flex flex-col lg:flex-row gap-16 items-center transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          {/* Left: Image block */}
          <div className="lg:w-5/12 relative">
            <div className="rounded-2xl overflow-hidden aspect-[4/5]">
              <img
                src="https://public.readdy.ai/ai/img_res/13f7e59775b64a58163f95a60e3a7a20.jpg"
                alt="BBM Services certified technicians Jacksonville FL"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating credential badge */}
            <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl p-5 shadow-lg border border-stone-100 max-w-[220px]">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-xl">
                  <i className="ri-award-fill text-brand-amber text-lg" />
                </div>
                <div>
                  <div className="font-bold text-brand-dark text-sm leading-none">CSIA Certified</div>
                  <div className="text-brand-warm-gray text-xs mt-0.5">Chimney Safety Institute</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-xl">
                  <i className="ri-wind-fill text-brand-amber text-lg" />
                </div>
                <div>
                  <div className="font-bold text-brand-dark text-sm leading-none">NADCA Member</div>
                  <div className="text-brand-warm-gray text-xs mt-0.5">Air Duct Cleaners Assoc.</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Content */}
          <div className="lg:w-7/12 lg:pl-6">
            <div className="inline-flex items-center gap-2 text-brand-amber text-xs font-bold uppercase tracking-widest mb-5">
              <div className="h-px w-8 bg-brand-amber" />
              About BBM Services
            </div>
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-brand-dark leading-tight mb-6">
              Jacksonville's Home Safety Cleaning Specialists Since 2010
            </h2>
            <p className="text-brand-warm-gray text-lg leading-relaxed mb-5">
              BBM Services was founded on a simple belief: Jacksonville homeowners deserve certified professionals who care about the health and safety of their homes. For over 15 years, we've been the trusted name in chimney cleaning, air duct cleaning, and dryer vent cleaning across the greater Jacksonville area.
            </p>
            <p className="text-brand-warm-gray text-base leading-relaxed mb-8">
              Our team of CSIA and NADCA certified technicians brings professional-grade equipment and genuine expertise to every job. We don't just clean — we educate homeowners on maintenance, identify hidden hazards, and make sure your home is safer when we leave than when we arrived.
            </p>

            {/* Values row */}
            <div className="grid grid-cols-2 gap-4 mb-8">
              {[
                { icon: 'ri-fire-fill', text: 'Chimney Safety Experts' },
                { icon: 'ri-lungs-line', text: 'Indoor Air Quality Focus' },
                { icon: 'ri-tools-line', text: 'Professional Equipment' },
                { icon: 'ri-heart-line', text: 'Family Safety First' },
              ].map((val) => (
                <div key={val.text} className="flex items-center gap-3 p-3 bg-amber-50 rounded-lg">
                  <div className="w-9 h-9 flex items-center justify-center bg-amber-100 rounded-lg flex-shrink-0">
                    <i className={`${val.icon} text-brand-amber`} />
                  </div>
                  <span className="text-brand-dark text-sm font-medium">{val.text}</span>
                </div>
              ))}
            </div>

            <Link
              to="/about"
              className="inline-flex items-center gap-2 bg-brand-amber hover:bg-brand-amber-dark text-white font-semibold py-3.5 px-7 rounded-lg text-sm transition-all cursor-pointer whitespace-nowrap"
            >
              Our Story
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line" />
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
